import { useState } from "react";
import { faqs } from "@/mocks/chiGuaData";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500/15 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-question-line" aria-hidden="true"></i> 常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            你可能想知道的
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            关于吃瓜网上与使用方式，常见问题这里都有答案。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {item.q}
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-primary-500 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                    aria-hidden="true"
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-200 pt-3 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}